import i18next from 'i18next';
import { Text } from '@wildberries/ui-kit';
import classnames from 'classnames/bind';
import { memo } from 'react';
import { WAREHOUSES_LIMITS_PAGE_TRANSLATIONS } from '@/pages/supplies-management/children/warehouses-limits/_constants/translations';
import { CoefficientTableCell } from '@/pages/supplies-management/_components/coefficient-table-cell';
import boxesIcon from '../../_assets/boxes-icon.svg';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Choose-warehouse';

export const ChooseWarehouse = memo(() => {
  return (
    <div className={cn(BLOCK_NAME)}>
      <div className={cn(`${BLOCK_NAME}__content`)}>
        <img
          alt=""
          className={cn(`${BLOCK_NAME}__img`)}
          loading="lazy"
          src={boxesIcon}
        />
        <Text
          color="greyDarker"
          size="h4-bold"
          text={i18next.t(
            WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.chooseWarehouseDescription,
          )}
        />
        <div className={cn(`${BLOCK_NAME}__coefficients-examples`)}>
          <div className={cn(`${BLOCK_NAME}__coefficients-examples-title`)}>
            <Text
              color="greyDarker"
              size="h4-bold"
              text={i18next.t(
                WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.coefficientsExamples,
              )}
            />
          </div>
          <div className={cn(`${BLOCK_NAME}__coefficients-list`)}>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <Text
                color="normalGrey"
                size="h4"
                text={i18next.t(
                  WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.coefficient,
                )}
              />
            </div>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <Text
                color="normalGrey"
                size="h4"
                text={i18next.t(WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.value)}
              />
            </div>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <CoefficientTableCell row={{ paidAcceptanceCoefficient: 0 }} />
            </div>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <Text
                size="h5"
                text={i18next.t(
                  WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.freeAcceptance,
                )}
              />
            </div>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <CoefficientTableCell row={{ paidAcceptanceCoefficient: 1 }} />
            </div>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <Text
                size="h5"
                text={i18next.t(
                  WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.equalToBaseCost,
                )}
              />
            </div>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <CoefficientTableCell row={{ paidAcceptanceCoefficient: 2 }} />
            </div>
            <div className={cn(`${BLOCK_NAME}__coefficients-list-item`)}>
              <Text
                size="h5"
                text={i18next.t(
                  WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.acceptanceFeeIncreased,
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
